import {
    WEBBRG_REQUEST,
    WEBBRG_REQUEST_SUCCESS,
    WEBBRG_REQUEST_ERROR,
} from '../actions/webbrg'

const initialState = {
    loading: false,
    clanNews: [],
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
    case WEBBRG_REQUEST: {
        return {
            loading: true,
            clanNews: [],
        }
    }
    case WEBBRG_REQUEST_SUCCESS: {
        return {
            loading: false,
            clanNews: action.payload.data,
        }
    }
    case WEBBRG_REQUEST_ERROR: {
        return {
            loading: false,
            clanNews: [],
        }
    }
    default: {
        return state
    }
    }
}


// WEBPACK FOOTER //
// ./state/reducers/webbrg.js